import { RouterProvider } from 'react-router/dom';
import { router } from './routes/AppRouter';
import {
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import axios from 'axios';
import { API_URL } from './constants/Environment';
import { AuthProvider } from './hooks/useAuth';
import { ToastContainer } from 'react-toastify';
import { LanguageProvider } from './contexts/LanguageContext';
import { queryKeys } from './queryKeys';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Sert les données en cache lors des revisites (navigation retour) au
      // lieu de relancer chaque requête — évite le « flash » de rechargement.
      // Les invalidations après mutation restent prioritaires.
      staleTime: 30_000,
    },
  },
  // Les compteurs du dashboard et les pages de stats agrègent toutes les
  // entités : n'importe quelle mutation réussie peut les rendre obsolètes.
  mutationCache: new MutationCache({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.stats.all });
    },
  }),
});

axios.defaults.baseURL = API_URL;

function App() {
  return (
    <div className="font-geist flex flex-col min-h-screen bg-brand-25">
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <AuthProvider>
            <RouterProvider router={router} />
            <ToastContainer />
          </AuthProvider>
        </LanguageProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
